import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
// import { List } from '@material-ui/core';
import { Subscription } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { BillingAddress, MyAccountClient, ShippingAddress, StateList, User, USPSAddressValidationRequest, USPSAddressValidationResponse } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
 

@Component({
    selector: 'app-user-address',
    templateUrl: './user-address.component.html',
    styleUrls: ['./user-address.component.css'],
    standalone: false
})
export class UserAddressComponent implements OnInit, OnDestroy {
  isLoading: any = {};
  form: UntypedFormGroup;
  statelist: StateList[];
  loggedUser: User;
  currentShippingAddressId:number;
  currentBillingAddressId:number;
  subscription!: Subscription;
  existingShippingAddress: ShippingAddress;
  existingBillingAddress: BillingAddress;
  isValidatingBillingAddress = false;
  isValidatingShippingAddress = false;
  billingAddressValidation: USPSAddressValidationResponse;
  shippingAddressValidation: USPSAddressValidationResponse;

  constructor(private formBuilder: UntypedFormBuilder, private myAccountClient: MyAccountClient, private commonService: CommonService, 
    private commonServices: CommonServices,private customServices:CustomServiceService) { }

  ngOnInit(): void {
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.GetForm();
    this.getStateList();
    this.listenShipingAsBillingChanges();
  }

   
  getStateList() {
    this.isLoading.stateList = true;
    this.myAccountClient.getStateList().subscribe(response => {
      this.statelist = response;
      this.isLoading.stateList = false;
      this.getBillingAddress();
      this.getShippingAddress();
    }, error => {
      this.isLoading.stateList = false;
      this.commonServices.showMessage('X', `Error found while getting state master`);
    });
  }

  getBillingAddress() {
    this.isLoading.billingAddress = true;
    this.subscription = this.commonService.billingAddress.subscribe(response => {
      if (response !== null) {
        this.existingBillingAddress = response;
        this.currentBillingAddressId = response.id;
        this.setBillingName(response.name);
        this.setBillingStreetAddress(response.street);
        this.setBillingCity(response.city);
        this.setBillingState(this.statelist.filter(x => x.id == response.stateId)[0]);
        this.setBillingZipCode(response.zipCode);
      }
      this.isLoading.billingAddress = false;
    });
  }

  getShippingAddress() {
    this.isLoading.shippingAddress = true;
    this.subscription = this.commonService.shippingAddress.subscribe(response => {
      if (response !== null) {
        this.existingShippingAddress = response;
        this.currentShippingAddressId = response.id;
        this.setShippingStreetAddress(response.street);
        this.setShippingCity(response.city);
        this.setShippingState(this.statelist.filter(x => x.id == response.stateId)[0]);
        this.setShippingZipCode(response.zipCode);
      }
      this.isLoading.shippingAddress = false;
    });
  }

  GetForm() {
    this.form = this.formBuilder.group({
      BillingName: ['', Validators.required],
      BillingStreetAddress: ['', Validators.required],
      BillingCity: ['', Validators.required],
      BillingState: ['', Validators.required],
      BillingZipCode: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]],
      ShipingAsBilling: [false],
      ShipingStreetAddress: ['', Validators.required],
      ShipingCity: ['', Validators.required],
      ShipingState: ['', Validators.required],
      ShipingZipCode: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]]
    });
  }

  listenShipingAsBillingChanges() {
    this.getShipingAsBilling.valueChanges.subscribe(res => {
      if (res) {
        this.getShipingStreetAddress.setValue(this.getBillingStreetAddress.value);
        this.getShipingCity.setValue(this.getBillingCity.value);
        this.getShipingState.setValue(this.getBillingState.value);
        this.getShipingZipCode.setValue(this.getBillingZipCode.value);

        this.form.controls['ShipingStreetAddress'].disable({emitEvent: false});
        this.form.controls['ShipingCity'].disable({emitEvent: false});
        this.form.controls['ShipingState'].disable({emitEvent: false});
        this.form.controls['ShipingZipCode'].disable({emitEvent: false});

        this.form.updateValueAndValidity();
      }
      else {
        this.form.controls['ShipingStreetAddress'].enable();
        this.form.controls['ShipingCity'].enable();
        this.form.controls['ShipingState'].enable();
        this.form.controls['ShipingZipCode'].enable();

        this.form.updateValueAndValidity();

        this.getShipingStreetAddress.setValue(this.existingShippingAddress ? this.existingShippingAddress.street : '');
        this.getShipingCity.setValue(this.existingShippingAddress ? this.existingShippingAddress.city : '');
        this.getShipingState.setValue(this.existingShippingAddress ? this.statelist.filter(x => x.id == this.existingShippingAddress.stateId)[0] : '');
        this.getShipingZipCode.setValue(this.existingShippingAddress ? this.existingShippingAddress.zipCode : '');
      }
    });
  }

  getBillingAddressObject() {
    var billingAddress = new BillingAddress();

    billingAddress.name = this.getBillingName.value;
    billingAddress.street = this.getBillingStreetAddress.value;
    billingAddress.city = this.getBillingCity.value;
    billingAddress.stateId = this.getBillingState.value.id;
    billingAddress.zipCode = this.getBillingZipCode.value;
    billingAddress.userId = this.loggedUser.id;
    billingAddress.isActive = true;
if(this.currentBillingAddressId != 0)
{
  billingAddress.id = this.currentBillingAddressId;
}
    return billingAddress;
  }

  getShippingAddressObject() {
    var shippingAddress = new ShippingAddress();

    shippingAddress.street = this.getShipingStreetAddress.value;
    shippingAddress.city = this.getShipingCity.value;
    shippingAddress.stateId = this.getShipingState.value.id;
    shippingAddress.zipCode = this.getShipingZipCode.value;
    shippingAddress.userId = this.loggedUser.id;
    shippingAddress.isActive = true;
    if(this.currentShippingAddressId != 0)
    {
      shippingAddress.id = this.currentShippingAddressId;
    }
    return shippingAddress;
  }

  SaveAddress() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.commonServices.showMessage("X", "Please fill all required fields which are marked with * and showing error.");
      return;
    }
    if (this.form.valid && !this.form.errors) {
      this.isLoading.saveBillingAddress = true;
      this.myAccountClient.saveBillingAddress(this.getBillingAddressObject()).subscribe(response => {
        this.commonService.setBillingAddress(response);
         this.commonServices.showMessage("Success", "Billing Address Saved Successfully");
         this.isLoading.saveBillingAddress = false;
      });
      this.isLoading.saveShippingAddress = true;
      this.myAccountClient.saveShippingAddress(this.getShippingAddressObject()).subscribe(response => {
        this.commonService.setShippingAddress(response);
        this.commonServices.showMessage("Success", "Shipping Address Saved Successfully");
        this.isLoading.saveShippingAddress = false;
      });
    }
  }

  setBillingName(BillingName) {
    this.getBillingName.setValue(BillingName);
  }

  setBillingStreetAddress(BillingStreetAddress) {
    this.getBillingStreetAddress.setValue(BillingStreetAddress);
  }

  setBillingCity(BillingCity) {
    this.getBillingCity.setValue(BillingCity);
  }

  setBillingState(BillingState) {
    this.getBillingState.setValue(BillingState);
  }

  setBillingZipCode(BillingZipCode) {
    this.getBillingZipCode.setValue(BillingZipCode);
  }

  setShiipingAsBilling(ShipngAsBilling) {
    this.getShipingAsBilling.setValue(ShipngAsBilling);
  }

  setShippingStreetAddress(ShipingStreetAddress) {
    this.getShipingStreetAddress.setValue(ShipingStreetAddress);
  }

  setShippingCity(ShipingCity) {
    this.getShipingCity.setValue(ShipingCity);
  }

  setShippingState(ShipingState) {
    this.getShipingState.setValue(ShipingState);
  }

  setShippingZipCode(ShipingZipCode) {
    this.getShipingZipCode.setValue(ShipingZipCode);
  }
  DisableButton()
  {
    return this.getShipingZipCode.errors?.required || this.getBillingStreetAddress.errors?.required
    || this.getBillingCity.errors?.required || this.getBillingState.errors?.required 
    || this.getBillingZipCode.errors?.required || this.getShipingAsBilling.errors?.required 
    || this.getShipingStreetAddress.errors?.required || this.getShipingCity.errors?.required 
    || this.getShipingState.errors?.required || this.getShipingZipCode.errors?.required  || this.getBillingState.value.id == undefined
  }
  ValidateBillingState()
{
  return (this.form.controls["BillingState"].touched && this.getBillingState.value.id == undefined) || this.getBillingState.errors?.required ;
}

  validateBillingAddress() {
    const streetAddress = this.form.controls['BillingStreetAddress'].value;
    const city = this.form.controls['BillingCity'].value;
    const selectedState = this.getBillingState.value;
    const state = selectedState?.stateCode || selectedState?.name || selectedState;
    const zipCode = this.form.controls['BillingZipCode'].value;

    if (!streetAddress || !city || !state || !zipCode) {
      this.commonServices.showMessage('error', 'Please fill in all billing address fields before validating.', 5);
      return;
    }

    this.isValidatingBillingAddress = true;
    const request = USPSAddressValidationRequest.fromJS({
      streetAddress: streetAddress,
      city: city,
      state: state,
      zipCode: zipCode
    });

    this.myAccountClient.validateAddress(request).subscribe(
      response => {
        this.isValidatingBillingAddress = false;
        this.billingAddressValidation = response;
        
        if (response.success && response.isValid) {
          // Update form with validated address
          if (response.validatedStreetAddress) {
            this.form.controls['BillingStreetAddress'].setValue(response.validatedStreetAddress);
          }
          if (response.validatedCity) {
            this.form.controls['BillingCity'].setValue(response.validatedCity);
          }
          if (response.validatedState) {
            const validatedState = this.statelist.find(s => s.stateCode === response.validatedState || s.name === response.validatedState);
            if (validatedState) {
              this.form.controls['BillingState'].setValue(validatedState);
            }
          }
          if (response.validatedZipCode) {
            this.form.controls['BillingZipCode'].setValue(response.validatedZipCode);
          }
          
          this.commonServices.showMessage('success', 'Billing address validated successfully!', 3);
        } else {
          this.commonServices.showMessage('warning', this.commonServices.friendlyAddressValidationMessage(response.errorMessage, response), 5);
        }
      },
      error => {
        this.isValidatingBillingAddress = false;
        this.commonServices.showMessage('error', 'Error validating address. Please try again.', 5);
      }
    );
  }

  validateShippingAddress() {
    const streetAddress = this.form.controls['ShipingStreetAddress'].value;
    const city = this.form.controls['ShipingCity'].value;
    const selectedState = this.getShipingState.value;
    const state = selectedState?.stateCode || selectedState?.name || selectedState;
    const zipCode = this.form.controls['ShipingZipCode'].value;

    if (!streetAddress || !city || !state || !zipCode) {
      this.commonServices.showMessage('error', 'Please fill in all shipping address fields before validating.', 5);
      return;
    }

    this.isValidatingShippingAddress = true;
    const request = USPSAddressValidationRequest.fromJS({
      streetAddress: streetAddress,
      city: city,
      state: state,
      zipCode: zipCode
    });

    this.myAccountClient.validateAddress(request).subscribe(
      response => {
        this.isValidatingShippingAddress = false;
        this.shippingAddressValidation = response;
        
        if (response.success && response.isValid) {
          // Update form with validated address
          if (response.validatedStreetAddress) {
            this.form.controls['ShipingStreetAddress'].setValue(response.validatedStreetAddress);
          }
          if (response.validatedCity) {
            this.form.controls['ShipingCity'].setValue(response.validatedCity);
          }
          if (response.validatedState) {
            const validatedState = this.statelist.find(s => s.stateCode === response.validatedState || s.name === response.validatedState);
            if (validatedState) {
              this.form.controls['ShipingState'].setValue(validatedState);
            }
          }
          if (response.validatedZipCode) {
            this.form.controls['ShipingZipCode'].setValue(response.validatedZipCode);
          }
          
          this.commonServices.showMessage('success', 'Shipping address validated successfully!', 3);
        } else {
          this.commonServices.showMessage('warning', this.commonServices.friendlyAddressValidationMessage(response.errorMessage, response), 5);
        }
      },
      error => {
        this.isValidatingShippingAddress = false;
        this.commonServices.showMessage('error', 'Error validating address. Please try again.', 5);
      }
    );
  }

  get getBillingName() {
    return this.form.controls["BillingName"];
  }
  get getBillingStreetAddress() {
    return this.form.controls["BillingStreetAddress"];
  }
  get getBillingCity() {
    return this.form.controls["BillingCity"];
  }
  get getBillingState() {
    return this.form.controls["BillingState"];
  }
  get getBillingZipCode() {
    return this.form.controls["BillingZipCode"];
  }
  get getShipingAsBilling() {
    return this.form.controls["ShipingAsBilling"];
  }
  get getShipingStreetAddress() {
    return this.form.controls["ShipingStreetAddress"];
  }
  get getShipingCity() {
    return this.form.controls["ShipingCity"];
  }
  get getShipingState() {
    return this.form.controls["ShipingState"];
  }
  get getShipingZipCode() {
    return this.form.controls["ShipingZipCode"];
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
